import { useCallback, useState } from "react";
import { Table, Space, Modal, notification } from "antd";
import { useRequest } from "../../hooks";
import { searchJobs, rescheduleJobs } from "../../api/job";
import EditJob from "./EditJob";
import { textRender } from "../../utils";
import IfNotObserver from "../common/IfNotObserver";
export default function () {
    const [refreshKey, setRefreshKey] = useState(Symbol())
    const fetchData = useCallback(() => {
        return searchJobs()
    }, [refreshKey]);
    const { data, loading } = useRequest(fetchData);
    const [showEditModal, setShowEditModal] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [edittingRecord, setEdittingRecord] = useState<JobRecord>();
    return (
        <div>
            <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
            </Space>
            <br /> <br />
            <Table
                columns={[
                    {
                        dataIndex: 'jobName',
                        title: '任务名',
                    },
                    {
                        dataIndex: 'description',
                        title: '任务描述',
                    },
                    {
                        dataIndex: 'type',
                        title: '任务类型',
                    },
                    {
                        dataIndex: 'interval',
                        title: '间隔时间(分)',
                        render: textRender
                    },
                    {
                        dataIndex: 'cron',
                        title: 'CRON表达式',
                        render: textRender
                    },
                    {
                        dataIndex: 'actions',
                        title: '操作',
                        render: (_, row) => {
                            return <IfNotObserver>
                                <a onClick={(e) => {
                                    e.preventDefault()
                                    setEdittingRecord(row)
                                    setShowEditModal(true)
                                }}>编辑</a>
                            </IfNotObserver>
                        }
                    }
                ]}
                loading={loading}
                dataSource={data}
            />
            <Modal destroyOnClose title="修改定时任务" footer={null} open={showEditModal} onCancel={() => { setShowEditModal(false) }}>
                <EditJob submitting={submitting} initialValues={edittingRecord} onSubmit={({ triggerName, name, ...values }) => {
                    setSubmitting(true)
                    rescheduleJobs({
                        ...values,
                        job: name,
                        trigger: triggerName,
                    })
                        .then(() => {
                            notification.success({ message: "修改成功" })
                            setRefreshKey(Symbol())
                            setShowEditModal(false)
                        })
                        .catch(() => {
                            notification.error({ message: "修改失败, 请重试" })
                        })
                        .finally(() => {
                            setSubmitting(false)
                        })
                }} />
            </Modal>
        </div>
    )
}